import { Injectable } from '@angular/core';
import { HttpService } from '@http';
import { ReplaySubject } from 'rxjs';
import { TokenService } from '@token';
import { PopupService } from '@popup';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private $store: ReplaySubject<any> = new ReplaySubject(1);
  readonly changes = this.$store.asObservable();
  isProfileLoaded = false;

  constructor(
    private $http: HttpService,
    private $popup: PopupService,
    private $token: TokenService,
  ) { }

  async fetchProfile() {
    try {
      const { data } = await this.$http.get('profile', {});
      this.setProfile(data);
    } catch ({ error }) {
      this.setProfile(null);
    }
  }
  get token(): string | null {
    return this.$token.value;
  }

  set token(value: string) {
    this.$token.value = value;
  }
  clearToken() {
    this.$token.clear();
  }

  async checkStaffPermission(module ) {
    return new Promise((resolve, reject) => {
      this.changes.subscribe(user => {

        if (user) {
          const permission = user.permission.some((permission) => {
            return permission.moduleName.toLowerCase() === module.toLowerCase();
          });
          resolve(permission);
        }
      });
    });
  }
  setProfile(data) {
    this.isProfileLoaded = true;
    this.$store.next(data);
  }

  async changePassword(oldPassword: string, newPassword: string) {
    const body = { oldPassword, newPassword };
    const { message } = await this.$http.patch('change-password', body);
    this.$popup.success(message);
  }

  logout() {
    localStorage.clear();
    this.$store.next(null);
  }
}
